import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  PrivatePage,
  AdminControls,
  OnboardingStatistics,
  SidebarGrid,
} from "@/components";

/**
 * Displays the admin page.
 */
const __default__ = {
  name: "AdminView",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PrivatePage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(SidebarGrid), null, {
        sidebar: _withCtx(() => [
          _createVNode(_unref(AdminControls))
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(OnboardingStatistics))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})